import { ReactNode } from 'react'
import classNames from 'classnames'

import { Theme } from 'client/utils'

import { AppParagraph, AppIcon, TextColor, TextDecoration, Size, AppDivider } from '..'
import { AppDividerProps } from '../AppDivider/app-divider'
import { AppIconProps } from '../AppIcon/app-icon'

import styles from './app-header.module.scss'

export type AppHeaderProps = {
  id?: string
  text: string
  size?: Size
  marginBottom?: boolean | Size
  color?: TextColor
  decoration?: TextDecoration
  dividing?: boolean
  centered?: boolean
  loading?: boolean
  disabled?: boolean
  highlightOnHover?: boolean
  rightSlot?: ReactNode
  theme?: Theme
  dataTestId?: string
  onClick?: (e) => void
  iconProps?: AppIconProps & { position?: 'left' | 'right' }
  dividerProps?: AppDividerProps
}

const AppHeader = (props: AppHeaderProps) => {
  const {
    id,
    text = '',
    size = 'medium',
    marginBottom = false,
    color,
    decoration,
    dividing = false,
    centered = false,
    loading = false,
    disabled = false,
    highlightOnHover = false,
    rightSlot = null,
    theme,
    dataTestId,
    onClick,
    iconProps,
    dividerProps,
  } = props

  const Icon = () => {
    return (
      <div className={classNames(styles.iconContainer, styles[iconProps.position])}>
        <AppIcon {...iconProps} size={iconProps.size || size} />
      </div>
    )
  }

  return (
    <>
      <div
        id={id}
        className={classNames(
          styles.appHeader,
          centered && styles.centered,
          onClick && styles.pointer
        )}
        onClick={onClick}
      >
        <div className={styles.headerContent}>
          {iconProps && [undefined, 'left'].includes(iconProps.position) ? (
            <Icon />
          ) : null}
          <div className={styles.paragraphContainer}>
            <AppParagraph
              isHeader
              text={text}
              size={size}
              color={color}
              decoration={decoration}
              loading={loading}
              disabled={disabled}
              highlightOnHover={highlightOnHover}
              theme={theme}
              dataTestId={dataTestId}
            />
          </div>
          {iconProps?.position === 'right' ? <Icon /> : null}
          {!loading && rightSlot && <div className={styles.rightSlot}>{rightSlot}</div>}
        </div>
      </div>
      {dividing && <AppDivider border size="xxsmall" {...dividerProps} />}
      {marginBottom && (
        <AppDivider size={marginBottom === true ? 'medium' : marginBottom} />
      )}
    </>
  )
}

export default AppHeader
